import * as serviceworker from '@losslessone_private/lele-serviceworker';
import * as domtools from '@designestate/dees-domtools';

import { html, render } from '@designestate/dees-element';
import { DefaultHeader } from './elements/header.js';

export { DefaultHeader };

const run = async () => {
  const domtoolsInstance = await domtools.DomTools.setupDomTools();
  domtools.elementBasic.setup();
  domtoolsInstance.setWebsiteInfo({
    metaObject: {
      title: 'Task Venture Capital GmbH - Open Source and Open Core for Enterprises',
      description:
        'a European company - creating Open Source solutions with TypeScript and Rust - operating SaaS platforms like social.io / layer.io / mojo.io / bellini.io / consent.software',
      canonicalDomain: 'https://bellini.io',
      ldCompany: {
        name: 'Task Venture Capital GmbH',
        status: 'active',
        contact: {
          address: {
            name: 'Task Venture Capital GmbH',
            city: 'Bremen',
            country: 'Germany',
            houseNumber: '16',
            postalCode: '28213',
            streetName: 'Ottilie-Hoffmann-Str.',
          },
          description: 'work',
          name: 'Task Venture Capital GmbH',
          type: 'company',
          facebookUrl: 'https://www.facebook.com/losslesscom',
          twitterUrl: 'https://twitter.com/losslesscom',
          website: 'https://lossless.com',
          phone: '+49 421 16767 548',
        },
        closedDate: null,
        foundedDate: {
          day: 1,
          month: 1,
          year: 2014,
        },
      },
    },
  });

  const serviceWorker = serviceworker.getServiceWorker();

  const mainTemplate = html`
    <style>
      body {
        margin: 0px;
        --background-accent: #303f9f;
      }
    </style>
    <default-header></default-header>
  `;

  render(mainTemplate, document.body);
};

run();
